@if (mappedFooterContentSections$ | async; as mappedFooterContentSections) {
  <div class="mt-ss-130px mx-32 w-full">
    <div class="w-full mb-10 flex flex-row text-white justify-between">
      @for (element of linkSections; track $index) {
        <div class="flex-1">
          @for (section of element; track $index) {
            <div class="mt-6">
              @if (mappedFooterContentSections[section]; as sectionData) {
                <h4 class="footer-header">
                  {{ sectionData.footerSectionTitle }}
                </h4>
                <ul>
                  @for (link of sectionData.footerSectionLinks; track $index) {
                    <li class="flex flex-col">
                      @if (link.page?.url) {
                        <a
                          [routerLink]="[link.page?.url]"
                          class="footer-link"
                          [innerHTML]="link.text"
                        ></a>
                      } @else if (!link.url?.startsWith('tel:')) {
                        <a
                          [href]="link.url"
                          class="footer-link"
                          [innerHTML]="link.text"
                        ></a>
                      } @else {
                        <p class="footer-link">{{ link.text }}</p>
                      }
                      @if (link.subText) {
                        <p
                          class="footer-subtext"
                          [innerHTML]="link.subText | splitLines: 'Tuesday'"
                        ></p>
                      }
                    </li>
                  }
                </ul>
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="mb-16 flex flex-row justify-between">
      <div class="flex flex-row gap-10">
        @for (social of socialLinks$ | async; track $index) {
          <a
            class="transform hover:scale-110 transition ease-out"
            [href]="social?.url"
            target="_blank"
          >
            <ss-www-image-with-loader
              class="w-[40px] aspect-[1/1]"
              [fileDetail]="social?.image"
              desktopImageSize="full"
            ></ss-www-image-with-loader>
          </a>
        }
      </div>
      <ss-button
        class="w-72"
        buttonColor="principal"
        buttonStyle="outlined"
        routerLink="/contact-us"
        >Contact Us</ss-button
      >
    </div>
    <div class="mb-12 gap-2 flex flex-col justify-center items-center">
      <ss-www-ampersand-logo></ss-www-ampersand-logo>
      <p class="text-[13px]">
        Copyright<span class="ss-superscript">©</span> {{ year }}, Sight & Sound
        Ministries Inc. All Rights Reserved
      </p>
      @if (mappedFooterContentSections['desktopPolicyLinks']; as policyLinks) {
        <ul class="flex flex-row gap-2 text-white">
          @for (item of policyLinks.footerSectionLinks; track $index) {
            <li class="after:content-['&#8226;']">
              @if (!item.page?.url && item.url?.startsWith('http')) {
                <a class="text-[13px] underline" [href]="item.url">{{
                  item.text
                }}</a>
              } @else {
                <a
                  class="text-[13px] underline"
                  [routerLink]="[item.page?.url ?? item.url ?? '#']"
                  >{{ item.text }}</a
                >
              }
            </li>
          }
        </ul>
      }
    </div>
  </div>
}
